/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { TranslationService } from 'src/app/shared/service/translation.service';

@Component({
  selector: 'app-profile-switch',
  templateUrl: './profile-switch.component.html',
  styleUrls: ['./profile-switch.component.scss']
})
export class ProfileSwitchComponent implements OnInit,OnDestroy {

  constructor(
    private readonly sharingData:SharingDataService,
    private readonly authAmplifyService: AuthAmplifyService,
    private readonly translationService:TranslationService
  ) { } 
  test:boolean=false
  isprofileswitchselected:boolean=false
  isMobileMenuVisible:boolean=false
  profileVisible:boolean=false
  isAliasSelected:any
  menuVisible:boolean=true
  userName:any
  userEmail:any
  subscriptions: Subscription[] = [];

  public ngOnInit(): void {
    this.userName=localStorage.getItem('userName')
    this.userEmail=localStorage.getItem('userEmail')
    this.isAliasSelected=localStorage.getItem("profile")
    this.subscriptions.push(this.sharingData.getProfileSwitched().subscribe((data)=>{
      if(data){
        this.isprofileswitchselected=true
      }
    }))

    this.sharingData.getProfileSelected().subscribe((data)=>{
      if(data){
        this.isprofileswitchselected=false
      }
    })
    
  }
  logout() {
    this.authAmplifyService.logout().subscribe(response => {
      window.location.href = response.body.data;
      
    });
  }
 
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

}
